/* supported sites */
export const SITE_REGEX = [/^https?:\/\/sanet\.(st|ls|ws)\/blogs\//]

/* supported folders */
export const FOLDER_REGEX = [
  /^https?:\/\/((prefiles.com\/folder\/)|(rapidgator.net\/folder\/)|(rg.to\/folder\/)|(prefiles.com\/\?usr_id))|(mega.nz\/folder\/)|(mega.co.nz\/folder\/)/,
]
